'use client';

import { LogParams } from '~/apis/log';
import { BUTTON_ID, EVENT_ACTION } from '~/apis/log/constant';
import { useEnvironmentInfo, useSendLog } from '~/hooks';
import { showSharePopupOnAosApp } from '~/services/app-interface';

export const useShareDocument = () => {
  const { deviceType } = useEnvironmentInfo();
  const sendLog = useSendLog();

  return ({ title, log }: { title?: string; log?: LogParams }) => {
    const currentUrl = new URL(globalThis.window.location.href);
    currentUrl.searchParams.delete('logContext');

    if (deviceType === 'android') {
      showSharePopupOnAosApp({ title, content: currentUrl.href }).go();
    } else {
      globalThis.window.navigator?.share?.({ title, url: currentUrl.href });
    }

    if (log) {
      sendLog({
        event_action: EVENT_ACTION.SELECT_BUTTON,
        button_id: BUTTON_ID.SHARE,
        ...log,
      });
    }
  };
};
